import { useState } from 'react';

import SignIn, { SignInProps } from './SignIn';
import ForgotPassword from './ForgotPassword';
import { AuthToken } from '../../models/AuthToken';
import { useUderlyStore } from '../../zustand';
import { setAxiosInterceptors } from "../../api";
import MagicAccess, { MagicAccessProps } from './MagicAccess';

enum States {
  checkExistance,
  signIn,
  passwordForgotten
}

interface AccessProps extends SignInProps, MagicAccessProps {
  enableMagicLink?: boolean;
}

const Access = (props: AccessProps) => {
  const [state, setState] = useState(props.enableMagicLink ? States.checkExistance : States.signIn);

  const { setToken, fetchUserInfo } = useUderlyStore((state) => {
    return { setToken: state.setToken, fetchUserInfo: state.fetchUserInfo };
  });

  const onSignedIn = async (data: AuthToken) => {
    setAxiosInterceptors(data.access_token);
    setToken(data);

    await fetchUserInfo();

    if (props.onSignedIn)
      props.onSignedIn(data);
  }

  return (
    <div className="auth-page">
      {state === States.checkExistance &&
        <MagicAccess onMagicLinkRequested={props.onMagicLinkRequested}
          onSignedIn={onSignedIn}
          onForgottenPassword={() => setState(States.passwordForgotten)} />}

      {state === States.signIn &&
        <SignIn onSignedIn={onSignedIn}
          onForgottenPassword={() => setState(States.passwordForgotten)} />}

      {state === States.passwordForgotten &&
        <ForgotPassword onCancel={() => setState(States.signIn)} onRequested={() => setState(States.signIn)} />}
    </div>);
};

export default Access;
